import { useMemo } from 'react';
import { LegacyTvChannelPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { transformTvProgram } from '../../channel-program/transformers/transform-tv-program';
import { getNotNullableItems } from '../../../lib/get-not-nullable-items';

export const useReadChannelPrograms = (channelInfo: LegacyTvChannelPlayerBaseInfoContent | null) =>
    useMemo(
        () => getNotNullableItems(channelInfo?.programs).map(transformTvProgram),
        [channelInfo?.programs]
    );
